<template>
  <v-container id="cashout-request-create">
    <v-row>
      <v-col>
        <MaterialCard
          elevation="0"
          color="primary"
          :title="this.$t('title.cashout_request_create')"
        >
          <div class="pa-5">
            <v-row>
              <v-col lg="8" cols="12">
                <v-form spellcheck="false" ref="cashoutform" v-model="valid">
                  <v-row>
                    <v-col lg="6" cols="12">
                      <v-text-field
                        :label="this.$t('label.name')"
                        :value="models.name"
                        :rules="rules.name"
                        readonly
                        filled
                        dense
                        outlined
                      ></v-text-field>
                      <v-text-field
                        :label="this.$t('label.administration_fee')"
                        :value="(models.administration_fee / 100) | currency"
                        :rules="rules.administration_fee"
                        readonly
                        filled
                        dense
                        outlined
                      ></v-text-field>
                      <v-text-field
                        validate-on-blur
                        :label="this.$t('label.amount')"
                        prefix="€"
                        v-money="money"
                        v-model="amount_euros"
                        :rules="rules.amount"
                        outlined
                      ></v-text-field>
                      <v-text-field
                        :label="this.$t('label.payout_amount')"
                        :value="(payout_amount / 100) | currency"
                        readonly
                        filled
                        dense
                        outlined
                      ></v-text-field>
                    </v-col>
                    <v-col lg="6" cols="12">
                      <v-text-field
                        :label="this.$t('label.city')"
                        :value="models.city"
                        :rules="rules.city"
                        readonly
                        filled
                        dense
                        outlined
                      ></v-text-field>
                      <v-text-field
                        :label="this.$t('label.payment_date')"
                        :value="models.payment_date"
                        :rules="rules.payment_date"
                        readonly
                        filled
                        dense
                        outlined
                      ></v-text-field>
                      <v-text-field
                        :label="this.$t('label.iban')"
                        v-model="models.iban"
                        :rules="rules.iban"
                        outlined
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-form>
              </v-col>
              <v-col class="text-center hidden-md-and-down" align-self="center">
                <v-icon size="150">mdi-currency-eur</v-icon>
              </v-col>
            </v-row>
          </div>
          <div class="pa-5">
            <v-btn
              @click="postCashout"
              class="no-text-transform display-1"
              color="primary"
              :loading="busyCreating"
              :disabled="!valid"
              >{{ this.$t("button.send") }}
            </v-btn>
          </div>
        </MaterialCard>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import MaterialCard from "../../../../../components/views/MaterialCard";
import { cashout_request_create } from "../../../../../mixins/cashout_request";

export default {
  name: "Cashout-Request",
  components: { MaterialCard },
  mixins: [cashout_request_create]
};
</script>

<style scoped></style>
